// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OTilie Answer Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CitationResponse } from './CitationResponse';
import {
    CitationResponseFromJSON,
    CitationResponseFromJSONTyped,
    CitationResponseToJSON,
    CitationResponseToJSONTyped,
} from './CitationResponse';

/**
 * 
 * @export
 * @interface AnswerResponse
 */
export interface AnswerResponse {
    /**
     * 
     * @type {string}
     * @memberof AnswerResponse
     */
    answer: string;
    /**
     * 
     * @type {Array<CitationResponse>}
     * @memberof AnswerResponse
     */
    citations: Array<CitationResponse>;
    /**
     * 
     * @type {number}
     * @memberof AnswerResponse
     */
    confidenceScore: number;
    /**
     * 
     * @type {AnswerResponseQueryLanguageEnum}
     * @memberof AnswerResponse
     */
    queryLanguage: AnswerResponseQueryLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof AnswerResponse
     */
    originalQuery: string;
    /**
     * 
     * @type {string}
     * @memberof AnswerResponse
     */
    currentQuery: string;
    /**
     * 
     * @type {string}
     * @memberof AnswerResponse
     */
    modelUsed: string;
    /**
     * 
     * @type {number}
     * @memberof AnswerResponse
     */
    generationTimeMs: number;
    /**
     * 
     * @type {string}
     * @memberof AnswerResponse
     */
    interactionId: string;
    /**
     * 
     * @type {number}
     * @memberof AnswerResponse
     */
    passagesRetrieved: number;
    /**
     * 
     * @type {number}
     * @memberof AnswerResponse
     */
    passagesForGeneration: number;
}


/**
 * @export
 */
export const AnswerResponseQueryLanguageEnum = {
    No: 'no',
    En: 'en',
    Da: 'da',
    Sv: 'sv',
    Fi: 'fi',
    De: 'de',
    Fr: 'fr',
    Es: 'es',
    Pl: 'pl',
    Ar: 'ar'
} as const;
export type AnswerResponseQueryLanguageEnum = typeof AnswerResponseQueryLanguageEnum[keyof typeof AnswerResponseQueryLanguageEnum];


/**
 * Check if a given object implements the AnswerResponse interface.
 */
export function instanceOfAnswerResponse(value: object): value is AnswerResponse {
    if (!('answer' in value) || value['answer'] === undefined) return false;
    if (!('citations' in value) || value['citations'] === undefined) return false;
    if (!('confidenceScore' in value) || value['confidenceScore'] === undefined) return false;
    if (!('queryLanguage' in value) || value['queryLanguage'] === undefined) return false;
    if (!('originalQuery' in value) || value['originalQuery'] === undefined) return false;
    if (!('currentQuery' in value) || value['currentQuery'] === undefined) return false;
    if (!('modelUsed' in value) || value['modelUsed'] === undefined) return false;
    if (!('generationTimeMs' in value) || value['generationTimeMs'] === undefined) return false;
    if (!('interactionId' in value) || value['interactionId'] === undefined) return false;
    if (!('passagesRetrieved' in value) || value['passagesRetrieved'] === undefined) return false;
    if (!('passagesForGeneration' in value) || value['passagesForGeneration'] === undefined) return false;
    return true;
}

export function AnswerResponseFromJSON(json: any): AnswerResponse {
    return AnswerResponseFromJSONTyped(json, false);
}

export function AnswerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnswerResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'answer': json['answer'],
        'citations': ((json['citations'] as Array<any>).map(CitationResponseFromJSON)),
        'confidenceScore': json['confidence_score'],
        'queryLanguage': json['query_language'],
        'originalQuery': json['original_query'],
        'currentQuery': json['current_query'],
        'modelUsed': json['model_used'],
        'generationTimeMs': json['generation_time_ms'],
        'interactionId': json['interaction_id'],
        'passagesRetrieved': json['passages_retrieved'],
        'passagesForGeneration': json['passages_for_generation'],
    };
}

export function AnswerResponseToJSON(json: any): AnswerResponse {
    return AnswerResponseToJSONTyped(json, false);
}

export function AnswerResponseToJSONTyped(value?: AnswerResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'answer': value['answer'],
        'citations': ((value['citations'] as Array<any>).map(CitationResponseToJSON)),
        'confidence_score': value['confidenceScore'],
        'query_language': value['queryLanguage'],
        'original_query': value['originalQuery'],
        'current_query': value['currentQuery'],
        'model_used': value['modelUsed'],
        'generation_time_ms': value['generationTimeMs'],
        'interaction_id': value['interactionId'],
        'passages_retrieved': value['passagesRetrieved'],
        'passages_for_generation': value['passagesForGeneration'],
    };
}

